/**
 * LocalStorage service
 * This class handles basic storage functionality like
 * saving data to localstorage, retriving and removing
 */
class LocalStorage {
    setCustomStyle(filename: string) {
        sessionStorage.setItem('customStyle', filename);
    }

    getCustomStyle() {
        return sessionStorage.getItem('customStyle');
    }

    setGroupLogo(logourl: string) {
        sessionStorage.setItem('groupLogo', logourl);
    }

    clearAll() {
        sessionStorage.removeItem('customStyle');
    }
}

export default new LocalStorage();
